import React, { Component } from 'react';

const ProviderSiteVisits = () => {
	return ( <h1>Provider Site Visits</h1> );
}
 
export default ProviderSiteVisits;